import React from 'react'
// hooks
import { useCurrentUser } from 'hooks/index'
// components
import Avatar from 'components/UI/Avatar'
// constants
import { Forms } from 'constants/index'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'
import { ActivitiesListBLContext } from 'containers/Activities/layers/BL/ActivitiesList'
import { ActivityBLContext } from 'containers/Activities/layers/BL/Activity'
// view components
import ActivityContent from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ActivityContent'
import CreateCommentForm from 'components/FormElements/ReduxForm/Forms/CreateCommentForm'
import ActivityActionsMenu from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ActionBar'
// views
import {
  Data,
  Wrapper,
  AuthorInfo,
  DateWrapper
} from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/views'
// types
import { IUser, LogActionTypes, LogEntityTypes } from 'types/graphql'
// utils
import { generateUserName } from 'utils/user'
import { formatActivityDate } from 'utils/date'

const ActivityDetails: React.FC = () => {
  // context
  const { canModifyResource, canDeleteResource } = React.useContext(ActivitiesListAPIContext)
  const { isReviewDetails, isReadOnly } = React.useContext(ActivitiesListBLContext)
  const { activity, handleCloseEditCommentForm, shouldShowCommentEditForm } = React.useContext(ActivityBLContext)

  // constants
  const isCreate = activity.actionType === LogActionTypes.Create
  const isUpdate = activity.actionType === LogActionTypes.Update
  const isDelete = activity.actionType === LogActionTypes.Delete

  const shouldShowResourceActionsMenu =
    activity.entityType === LogEntityTypes.Resource && (canModifyResource || canDeleteResource)

  const shouldShowActionsMenu =
    !isReadOnly &&
    !isDelete &&
    (activity.entityType === LogEntityTypes.Image ||
      activity.entityType === LogEntityTypes.Link ||
      activity.entityType === LogEntityTypes.Comment ||
      shouldShowResourceActionsMenu)

  const currentUser: IUser = useCurrentUser()
  const activityCreator = activity.user || {}

  const isOwnActivity = currentUser.id === activityCreator.id

  return (
    <Wrapper>
      {!isReviewDetails && <Avatar user={activityCreator} />}

      {shouldShowCommentEditForm ? (
        <CreateCommentForm form={Forms.EDIT_COMMENT_FORM} isCommentEdit handleCloseForm={handleCloseEditCommentForm} />
      ) : (
        <Data>
          <AuthorInfo>
            {generateUserName(activityCreator)}
            <DateWrapper>{formatActivityDate(currentUser.timezone, activity.createdAt)}</DateWrapper>
          </AuthorInfo>

          <ActivityContent isCreate={isCreate} isUpdate={isUpdate} isDelete={isDelete} />

          {shouldShowActionsMenu && <ActivityActionsMenu isOwnActivity={isOwnActivity} />}
        </Data>
      )}
    </Wrapper>
  )
}

export default ActivityDetails
